import { useEffect, useState } from "react";
import axios from "axios";

const EMPTY = { certibiocide: "", rc_pro: "", siret: "", prices: {} };
let cache = null;

export function useSiteSettings() {
  const [settings, setSettings] = useState(cache && !cache.then ? cache : EMPTY);
  useEffect(() => {
    if (!cache) {
      cache = axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
        .then((r) => r.data)
        .catch(() => EMPTY);
    }
    Promise.resolve(cache).then((s) => {
      cache = s;
      setSettings(s);
    });
  }, []);
  return settings;
}

export function resetSiteSettingsCache() {
  cache = null;
}
